import {useContext, useMemo} from "react";

import MessageService from "../../../services/message";
import {HTTPContext} from "../../contexts";

export const useMessageService = () => {
    const http = useContext(HTTPContext);
    return useMemo(() => new MessageService(http), [http]);
};
